<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form">
			<el-form-item>
				<el-icon :size="20" @click='getBack()'>
					<DArrowLeft />
				</el-icon>
				<h3 v-if='!selfIs'>用户角色</h3>
				<h3 style='margin-left:10px' v-else>用户角色（当前登录用户）</h3>
			</el-form-item>
			<el-form-item>
				<el-button type='primary' @click="openRoleShow">增加角色</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="infoData.tableData" stripe border v-loading='infoData.loading' height='86%'>
			<el-table-column type="index" width="50" />
			<el-table-column prop="hj_m_role.name" label="角色名称" />
			<!-- <el-table-column prop="path" label="路径" width="160" />
			<el-table-column prop="mLevel" label="菜单等级" width="100" />
			<el-table-column prop="sequence" label="排序" width="100" /> -->
			<el-table-column width="100" fixed="right" label="操作">
				<template #default="scope">
					<!-- <el-button type="success" size="small" @click="handleClickEdit(scope.row)">编辑</el-button> -->
					<el-popconfirm title="确定删除吗?" @confirm="handleClickDel(scope.row.id)">
						<template #reference>
							<el-button type="danger" size="small">删除</el-button>
						</template>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog v-model="infoData.addRoleShow" title="配置角色" width="30%" :before-close="handleClose">
			请选择角色：<el-select v-model="infoData.role" value-key='id' class="m-2" placeholder="请选择" size="large">
				<el-option v-for="item in infoData.roleList" :key="item.id" :label="item.name" :value="item" />
			</el-select>
			<template #footer>
				<span class="dialog-footer" style="margin: 0 auto;">
					<el-button @click="infoData.addRoleShow = false">取消</el-button>
					<el-button type="primary" @click="handleEditUserRole">确定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive
	} from "vue-demi";
	import api from "../../http/apis"
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	import {
		useRouter,
		useRoute
	} from 'vue-router'
	import {
		DArrowLeft
	} from '@element-plus/icons-vue'
	export default {
		setup() {
			const store = useStore();
			const router = useRouter();
			const userId = router.currentRoute.value.query.id
			const selfIs = router.currentRoute.value.query.type
			const selfId = router.currentRoute.value.query.id
			const infoData = reactive({
				tableData: [],
				loading: false,
				addRoleShow: false,
				roleList: [],
				role: '',
				roleCheckedInfo: {}
			});
			const getUserRole = async () => {
				if (!selfIs) {
					infoData.loading = true
					const {
						data
					} = await api.userApi.queryUserRole(userId);
					if (data.isSuccessful) {
						infoData.loading = false
						infoData.tableData = data.resultObj
					} else if (data.resultMsg) {
						ElMessage({
							message: data.resultMsg,
							type: "error",
						});
					} else {
						ElMessage({});
					}
				} else {
					infoData.loading = true
					const {
						data
					} = await api.userApi.queryUserRoleSelf();
					if (data.isSuccessful) {
						infoData.loading = false
						infoData.tableData = data.resultObj
					} else if (data.resultMsg) {
						ElMessage({
							message: data.resultMsg,
							type: "error",
						});
					} else {
						ElMessage({});
					}
				}
			};
			getUserRole()
			return {
				infoData,
				userId,
				getUserRole,
				selfIs
			};
		},
		activated() {
			this.getUserRole()
		},
		methods: {
			async getRoleList() {
				const {
					data
				} = await api.userApi.queryRole();
				if (data.isSuccessful) {
					this.infoData.roleList = data.resultObj
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			},
			async handleEditUserRole() {
				// console.log(this.infoData.roleCheckedInfo.id)
				const {
					data
				} = await api.userApi.editUserRole({
					dcUserId: parseInt(this.userId) || this.selfId,
					id: this.infoData.roleCheckedInfo.id || 0,
					roleId: this.infoData.role.id,
					// hj_m_role: this.infoData.role,
				});
				if (data.isSuccessful) {
					this.infoData.roleCheckedInfo = {}
					ElMessage({
						message: data.resultMsg,
						type: "success",
					});
					this.infoData.addRoleShow = false
					this.getUserRole()
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			},
			handleClickEdit(info) {
				this.openRoleShow()
				this.infoData.roleCheckedInfo = info
				this.infoData.role = this.infoData.roleCheckedInfo.hj_m_role
			},
			async handleClickDel(id) {
				const {
					data
				} = await api.userApi.deleteUserRole(id);
				if (data.isSuccessful) {
					ElMessage({
						message: data.resultMsg,
						type: "success",
					});
					this.getUserRole()
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			},
			openRoleShow() {
				this.infoData.addRoleShow = true
				this.getRoleList()
			},
			handleClose() {
				this.infoData.addRoleShow = false
				this.infoData.role = ''
				this.infoData.roleCheckedInfo = {}
			},
			getBack() {
				window.history.go(-1)
			},
		}
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;
</style>
